//
// locale_cy.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/cy.json';
import localeData from "react-intl/locale-data/cy.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
